import { ShadowsExample } from 'components/designSystem/utilityClasses/ShadowsExample';
import { UtilityClass } from 'components/designSystem/utilityClasses/UtilityClass';
import { UtilityClassSectionHeader } from 'components/designSystem/utilityClasses/UtilityClassSectionHeader';
import { Section } from 'components/shared/Section';

const shadows = [
    <UtilityClassSectionHeader key="1" />,
    <div key="2">
        <UtilityClass
            className="%shadow__header"
            example={<ShadowsExample className="shadow__header" lightMode />}
        />
        <UtilityClass
            className="%shadow__header--dark"
            example={<ShadowsExample className="shadow__header--dark" />}
        />
        <UtilityClass
            className="%shadow__dialog--dark"
            example={<ShadowsExample className="shadow__dialog--dark" />}
        />
        <UtilityClass
            className="%shadow__dragging"
            example={<ShadowsExample className="shadow__dragging" lightMode />}
        />
        <UtilityClass
            className="%shadow__dragging--dark"
            example={<ShadowsExample className="shadow__dragging--dark" />}
        />
        <UtilityClass
            className="%shadow__container--bottom"
            example={<ShadowsExample className="shadow__container--bottom" lightMode />}
        />
        <UtilityClass
            className="%shadow__container--bottom--dark"
            example={<ShadowsExample className="shadow__container--bottom--dark" />}
        />
        <UtilityClass
            className="%shadow__button"
            example={<ShadowsExample className="shadow__button" lightMode />}
        />
        <UtilityClass
            className="%shadow__button--dark"
            example={<ShadowsExample className="shadow__button--dark" />}
        />
        <UtilityClass
            className="%shadow__button--hover"
            example={<ShadowsExample className="shadow__button--hover" lightMode />}
        />
        <UtilityClass
            className="%shadow__button--hover--dark"
            example={<ShadowsExample className="shadow__button--hover--dark" />}
        />
        <UtilityClass
            className="%shadow__button--pressed"
            example={<ShadowsExample className="shadow__button--pressed" />}
        />
        <UtilityClass
            className="%shadow__card"
            example={<ShadowsExample className="shadow__card" lightMode />}
        />
        <UtilityClass
            className="%shadow__card--dark"
            example={<ShadowsExample className="shadow__card--dark" />}
        />
        <UtilityClass
            className="%shadow__card__expanded-container"
            example={<ShadowsExample className="shadow__card__expanded-container" lightMode />}
        />
        <UtilityClass
            className="%shadow__card__expanded-container--dark"
            example={<ShadowsExample className="shadow__card__expanded-container--dark" />}
        />
        <UtilityClass
            className="%shadow__popover--dark"
            example={<ShadowsExample className="shadow__popover--dark" />}
        />
        <UtilityClass
            className="%shadow__popover-arrow--dark"
            example={<ShadowsExample className="shadow__popover-arrow--dark" />}
        />
    </div>,
];

export const Shadows = () => <Section title="Shadow Utility Classes" contentArray={shadows} />;
